import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import { fetchEvents, fetchEventsCompanyParticipation, fetchEventsMetrics, fetchResources, fetchAllEvents } from './index';
import {
    EventParticipationDto,
    IEvent,
    IEventMetrics,
    IFetchEventMetricsRequestParams,
    IFetchEventsCompanyParticipationRequestParams,
    IFetchEventsRequestParams,
    IFetchResourcesRequestParams,
} from './interface';
import { IResource } from './resource';

export const useEventListQuery = (params: IFetchEventsRequestParams, options = {}) => {
    return useQuery<IPagination<IEvent>, Error>({
        queryKey: [QueryKey.EVENTS, params],
        queryFn: () => fetchEvents(params),
        refetchOnMount: 'always',
        ...options,
    });
};

export const useAllEventListQuery = (params: IFetchEventsRequestParams, options = {}) => {
    return useQuery<IEvent[], Error>({
        queryKey: [QueryKey.EVENTS, params],
        queryFn: ({ signal }) => fetchAllEvents(params, signal),
        keepPreviousData: true,
        ...options,
    });
};

export const useEventMetricsQuery = (params: IFetchEventMetricsRequestParams, options = {}) => {
    return useQuery<IEventMetrics, Error>({
        queryKey: [QueryKey.EVENTS_METRICS, params],
        queryFn: () => fetchEventsMetrics(params),
        ...options,
    });
};

export const useResourceListQuery = (params: IFetchResourcesRequestParams, options = {}) => {
    return useQuery<IResource[], Error>({
        queryKey: [QueryKey.RESOURCES, params],
        queryFn: ({ signal }) => fetchResources(params, signal),
        ...options,
    });
};

export const useEventCompanyParticipationListQuery = (params: IFetchEventsCompanyParticipationRequestParams, options = {}) => {
    return useQuery<EventParticipationDto[], Error>({
        queryKey: [QueryKey.EVENTS_COMPANY_PARTICIPATION, params],
        queryFn: () => fetchEventsCompanyParticipation(params),
        ...options,
    });
};
